import React from 'react';
import styled from 'styled-components';
import { ProductCardButton } from '@sparknz/spark-pattern-library';

import { useSelectedPlans } from 'components/shop/MobilePlans/providers';
import { isPack } from 'components/shop/MobilePlans/utils/isPack.utils';
import { trackSelectPlanEvent } from 'components/shop/MobilePlans/utils/tracking.utils';
import { PlanCardQuantitySelection } from '../../PlanCard/components';

export interface MpdPlansProps {
  planId: string;
  planName: string;
  price: number;
  quantity: number;
}

export type QuantityAction = 'increase' | 'decrease';

export const StyledProductCardButton = styled(ProductCardButton)`
  margin-bottom: 0;
`;

interface MpdPlanCardSelectProps {
  planId: string;
  planName: string;
  relatedOfferId?: string | null;
  relatedOfferIds?: readonly string[] | null;
  isTeamUpEligible: boolean;
  isMultiPlanEnabled: boolean;
}

const MpdPlanCardSelect = ({
  planId,
  planName,
  relatedOfferId,
  relatedOfferIds,
  isTeamUpEligible,
  isMultiPlanEnabled,
}: MpdPlanCardSelectProps) => {
  const {
    selectIndividualPlan,
    increaseSelectedPlan,
    decreaseSelectedPlan,
    getSelectedPlanQuantity,
    openSelectedPlansLayer,
  } = useSelectedPlans();

  const planQuantity = getSelectedPlanQuantity(planId);

  const handleClick = () => {
    trackSelectPlanEvent();

    if (isMultiPlanEnabled) {
      increaseSelectedPlan(planId, planName, isTeamUpEligible);
    } else {
      selectIndividualPlan(planId, planName, {
        isTeamUpEligible,
        isPrimary: true,
        relatedOfferId,
        relatedOfferIds,
        skipGuestLogin: true,
      });
      openSelectedPlansLayer();
    }
  };

  if (planQuantity && isMultiPlanEnabled) {
    return (
      <PlanCardQuantitySelection
        handleDecrease={decreaseSelectedPlan}
        handleIncrease={increaseSelectedPlan}
        planId={planId}
        planName={planName}
        planQuantity={planQuantity}
        isTeamUpEligible={isTeamUpEligible}
      />
    );
  }

  return (
    <StyledProductCardButton variant="primary" onClick={handleClick}>
      {isPack(planName) ? 'Select pack' : 'Select plan'}
    </StyledProductCardButton>
  );
};

export default MpdPlanCardSelect;
